import React, { Component } from "react";
import { Form, Spinner } from "react-bootstrap";
import { Redirect } from "react-router-dom";
import { BaseUrl, Authorization, LogoutFunction } from "../static.js";

export default class Password extends Component {
  constructor(props) {
    super(props);
    this.state = {
      passwordErrorText: "",
      passwordValue: "",
      buttonText: true,
      buttonSpinner: false,
      buttonDisabled: false,
      actionError: "",
    };
    this.passwordHandleChange = this.passwordHandleChange.bind(this);
    this.onLogin = this.onLogin.bind(this);
    this.passwordInput = React.createRef();
  }

  componentDidMount() {
    this.props.onSubmitMobile();
    this.passwordInput.current.focus();
  }

  handleKeyPress(target) {
    if (target.charCode === 13) {
      this.onLogin();
    }
  }

  passwordHandleChange(event) {
    this.setState({ passwordValue: event.target.value });
  }

  onForgetPassword() {
    // let country='';
    // let number='';
    // if (isValidPhoneNumber(sessionStorage.getItem("mobile")) && isPossiblePhoneNumber(sessionStorage.getItem("mobile"))){
    //     let numberInfo=parsePhoneNumber(sessionStorage.getItem("mobile"));
    //     country=numberInfo.country;
    //     number=numberInfo.number;
    //     this.setState({actionError:''})
    // }else{
    //     this.setState({actionError:'incorrect number. please enter your number with country code'})
    //     return;
    // }

    this.setState({ buttonDisabled: true });
    let data = {
      mobile: sessionStorage.getItem("mobile"),
      country: "IR",
    };

    fetch(BaseUrl + "forgetPassword", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          console.log(result);
          sessionStorage.setItem("userStatus", "forget");
          this.props.onForgetPassword();
        } else {
          this.setState({
            buttonDisabled: false,
            actionError:
              "اتصال با سرور با مشکل مواجه شد. از اتصال دستگاه به اینترنت اطمینان حاصل فرمائید.",
          });
        }
      });

    // this.props.onForgetPassword();
  }

  onLogin() {
    this.setState({ actionError: "" });

    if (this.state.passwordValue === "") {
      this.setState({ actionError: "لطفاً کلمه عبور را وارد کنید" });
      return;
    } else {
      this.setState({ actionError: "" });
    }

    if (this.state.passwordValue.length >= 8) {
      this.setState({ actionError: "" });
    } else {
      this.setState({ actionError: "کلمه عبور اشتباه است" });
      return;
    }

    this.setState({
      buttonText: false,
      buttonSpinner: true,
      buttonDisabled: true,
    });

    let data = {
      mobile: sessionStorage.getItem("mobile"),
      password: this.state.passwordValue,
    };

    fetch(BaseUrl + "login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          localStorage.setItem("token", result.token);
          localStorage.setItem("mobile", sessionStorage.getItem("mobile"));
          sessionStorage.clear();
          this.props.onCorrectPassword();
        } else if (result.status === 401) {
          this.setState({
            buttonText: true,
            buttonSpinner: false,
            buttonDisabled: false,
            actionError: "کلمه عبور اشتباه است",
          });
        } else {
          this.setState({
            buttonText: true,
            buttonSpinner: false,
            buttonDisabled: false,
            actionError:
              "اتصال با سرور با مشکل مواجه شد. از اتصال دستگاه به اینترنت اطمینان حاصل فرمائید.",
          });
        }
      });
  }

  onGoBack() {
    this.props.onPasswordBack();
  }

  render() {
    if (
      sessionStorage.getItem("mobile") !== null &&
      sessionStorage.getItem("mobile") !== ""
    ) {
      return (
        <div className="PasswordPage">
          <div className="inputHeader">
            {/* <div>تلفن همراه:&nbsp;{sessionStorage.getItem("mobile")}</div> */}
            <div style={{ display: "flex", flexDirection: "row" }}>
              تلفن همراه:&nbsp;
              <div style={{ direction: "ltr" }}>
                {sessionStorage.getItem("mobile").replace("+98", "0")}
              </div>
            </div>
            <div>
              <div
                onClick={
                  this.state.buttonDisabled
                    ? (event) => event.preventDefault()
                    : this.onForgetPassword.bind(this)
                }
                className="linkStyle"
                style={{
                  fontSize: "12px",
                  margin: "0",
                  fontFamily: "SFUIDisplay",
                }}
              >
                کلمه عبور را فراموش کرده‌ام
              </div>
            </div>
          </div>
          <Form.Control
            className={
              this.state.actionError !== ""
                ? "inputStyle inputStyleError"
                : "inputStyle"
            }
            style={{ direction: "ltr" }}
            placeholder="کلمه عبور را وارد کنید"
            type="password"
            name="password"
            id="password"
            onChange={this.passwordHandleChange}
            value={this.state.passwordValue}
            disabled={this.state.buttonDisabled}
            onKeyPress={this.handleKeyPress.bind(this)}
            ref={this.passwordInput}
          />

          <div className="errorMessageContainer">{this.state.actionError}</div>

          {!this.state.buttonDisabled && (
            <div
              onClick={
                this.state.buttonDisabled
                  ? (event) => event.preventDefault()
                  : this.onLogin
              }
              className="linkStyle"
            >
              ورود
            </div>
          )}
          {this.state.buttonDisabled && (
            <Spinner
              style={{
                color: "var(--brown)",
                height: "20px",
                width: "20px",
                marginTop: "20px",
              }}
              animation="border"
            />
          )}

          {/* <div onClick={this.state.buttonDisabled ? (event) => event.preventDefault(): this.onGoBack.bind(this)} className="linkStyle backButton"><FontAwesomeIcon className="backButtonIcon" icon={faChevronLeft} />بازگشت</div> */}
        </div>
      );
    } else {
      return <Redirect to="/Login" />;
    }
  }
}
